import { Box, useTheme } from "@mui/material";
import { ReactElement } from "react";
import NavBackButton from "../../../components/NavBackButton";
import { useAppSelector } from "../../../../hooks/useRedux";

interface Props {
  hasScroll?: boolean;
  title: ReactElement;
}

export default function MobileHeader({ title }: Props) {
  const theme = useTheme();

  const hasScroll = useAppSelector((state) => state.settings.hasScroll);

  return (
    <Box
      sx={{
        position: "fixed",
        maxWidth: "450px",
        top: "0px",
        width: "100%",
        zIndex: 150,
        backgroundColor: theme.palette.bgColor.grey100,
        transition: "box-shadow 500ms",
        boxShadow: hasScroll ? "0px 4px 8px 3px rgba(0,0,0,0.1)" : "none",
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        paddingY: "12px",
        paddingX: "8px",
      }}
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          gap: "8px",
        }}
      >
        <NavBackButton />
        {title}
      </Box>

      {/* <NotifSingleButton path="/owner/notifs" /> */}
    </Box>
  );
}
